import React from "react";
import { Route, Routes } from "react-router-dom";

import { FundingView } from "../components/FundingView";
import { ToggleHomeView } from "../security/ToggleViews";
import { PartnershipView } from "../components/PartnershipView";
import { ScienceClubView } from "../components/ScienceClubView";
import { SettingsView } from "../components/SettingsView";
import { UserAdminView } from "../components/UserAdminView";
import { WorklistView } from "../components/WorklistView";
import CreatePartner from "../components/partners/CreatePartner";
import EditPartner from "../components/partners/EditPartner";
import ViewCandidate from "../components/saasta/ViewCandidate";
import ViewEvent from "../components/eventsmanagement/eventsratification/eventsinfo/ViewEventDetails";
import DataImport from "../components/stemiolympiad/stemiupload/DataUpload";
import DataUpload from "../components/datamigration/DataUpload"
import History from "../components/stemiolympiad/stemiupload/History";
import ApplicationErrorList from "../components/systemerrors/ApplicationErrorList";
import ViewApplicationLogs from "../components/systemerrors/ViewApplicationLogs";
import OfflinePage from "../security/AuthOffline";
import AuthOffline from "../security/AuthOffline";
import FaqView from "../components/adminconfig/faq/FaqView";
import NYSProgrammeView from "../components/NYSProgrammeView";
import FinYearView from "../components/FinYearView";
import DocumentView from "../components/documentrepository/MainPage";
import ViewDocumentDetails from "../components/documentrepository/ViewDocumentDetails";
import RepoLookupView from "../components/documentrepository/lookup/RepoLookupView";
import SystemConfig from '../components/adminconfig/adminconfigs/SystemConfig';
import AgentUploadHistory from "../components/stemiolympiad/stemiupload/AgentUploadHistory";
import UploadHistory from "../components/datamigration/UploadHistory";
import StemiOlympiadNameView from "../components/adminconfig/stemi/olympiadnames/OlympiadNameView";
import UserGuideView from "../components/userguide/UserGuideView";

import ViewProjectDetails from "src/components/citizenscience/projectinfo/ViewProjectDetails";
import AddressList from "src/components/adminconfig/address/AddressList";
import NysView from "src/components/nys/NysView";
import ProjectView from "src/components/citizenscience/ProjectView";
import VolunteerScientistHome from "src/components/volunteerscientist/VolunteerScientistHome"
import VolunteerScientistDetail from "src/components/volunteerscientist/VolunteerScientistDetail";
import EventListView from "src/components/eventsmanagement/EventView";

import {
  ViewDocument,
  EventsReport,
  PartnerReport,
  NYSReport,
  STEMIOlympiadReport as StemiReport,
  InvalidPage,
  EventsGeographicReport,
  CitizenScienceReport,
  VolunteerScientistReport,
  UserProfile,
  UserChangePassword,
} from '@seims/shared';
import { AuthenticatedRoute, RouteByRole } from "@seims/shared/src/security";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<ToggleHomeView />} />
      <Route path="/autherror" element={<AuthOffline />} />
      <Route
        path="/partnership"
        element={
          <RouteByRole
            roles={["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]}
          >
            <PartnershipView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/partnership/new"
        element={
          <RouteByRole
            roles={["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]}
          >
            <CreatePartner />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/partnership/:key"
        element={
          <RouteByRole
            roles={["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]}
          >
            <EditPartner />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/worklist"
        element={
          <RouteByRole roles={["ADMIN", "CORE"]}>
            <WorklistView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/funding"
        element={
          <RouteByRole roles={["ADMIN", "CORE"]}>
            <FundingView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/scienceclub"
        element={
          <RouteByRole roles={["ADMIN", "CORE"]}>
            <ScienceClubView />
          </RouteByRole>
        }
      />
      <Route
        path="/usermanagement"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <UserAdminView />
          </RouteByRole>
        }
      />
      <Route
        path="/config"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <SettingsView />{" "}
          </RouteByRole>
        }
      />

      <Route
        path="/faq"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <FaqView />{" "}
          </RouteByRole>
        }
      />

      <Route
        path="/nysprogramme"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <NYSProgrammeView />{" "}
          </RouteByRole>
        }
      />

      <Route
        path="/finyear"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <FinYearView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/document-repository/view"
        element={
          <AuthenticatedRoute>
            <ViewDocument />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/document-repository/view-more/:id"
        element={
          <RouteByRole
            roles={["ADMIN", "DSI_OFFICIAL", "SAASTA_OFFICIAL", "HSRC"]}
          >
            <ViewDocumentDetails />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/document-repository/manage"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "DOCUMENT_REPO_RATIFIER",
              "DOCUMENT_REPO_UPLOADER",
            ]}
          >
            <DocumentView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/document-repository/configuration"
        element={
          <RouteByRole
            roles={["ADMIN", "DSI_OFFICIAL", "SAASTA_OFFICIAL", "HSRC"]}
          >
            <RepoLookupView />{" "}
          </RouteByRole>
        }
      />

      <Route
        path="/profile"
        element={
          <AuthenticatedRoute>
            <UserProfile />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/changepassword"
        element={
          <AuthenticatedRoute>
            <UserChangePassword />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/partnershipreports"
        element={
          <AuthenticatedRoute>
            <PartnerReport />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/nysreports"
        element={
          <AuthenticatedRoute>
            <NYSReport />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/event/venue-type-report"
        element={
          <AuthenticatedRoute>
            <EventsReport eventType="Venue Type" filterType="venue" />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/event/group-report"
        element={
          <AuthenticatedRoute>
            <EventsReport eventType="Event Group" filterType="group" />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/event/individual-report"
        element={
          <AuthenticatedRoute>
            <EventsReport eventType="Individual Event" filterType="event" />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/event/location-report"
        element={
          <AuthenticatedRoute>
            <EventsGeographicReport
              eventType="Event Location"
              filterType="event"
            />{" "}
          </AuthenticatedRoute>
        }
      />

      <Route
        path="/citizen-science"
        element={
          <AuthenticatedRoute>
            <CitizenScienceReport />{" "}
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/candidate"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "CORE",
              "DSI_OFFICIAL",
              "SAASTA_OFFICIAL",
              "HSRC_OFFICIAL",
            ]}
          >
            {/* <CandidatesList /> */}
            <NysView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/candidate/:key"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "CORE",
              "DSI_OFFICIAL",
              "SAASTA_OFFICIAL",
              "HSRC_OFFICIAL",
            ]}
          >
            <ViewCandidate />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/candidate/:key"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "CORE",
              "DSI_OFFICIAL",
              "SAASTA_OFFICIAL",
              "HSRC_OFFICIAL",
            ]}
          >
            <ViewCandidate />{" "}
          </RouteByRole>
        }
      />

      <Route
        path="/candidate/status/:status"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "CORE",
              "DSI_OFFICIAL",
              "SAASTA_OFFICIAL",
              "HSRC_OFFICIAL",
            ]}
          >
            {/* <CandidatesList />{" "} */}
            <NysView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/events-management"
        element={
          <RouteByRole
            roles={[
              "ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD",
            ]}
          >
            <EventListView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/events-management/status/:status"
        element={
          <RouteByRole
            roles={[
              "ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD",
            ]}
          >
            <EventListView />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/events-management/event/:key"
        element={
          <RouteByRole roles={["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD"]}>
            <ViewEvent />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/stemiolympiad/overview"
        element={
          <AuthenticatedRoute>
            <StemiReport reportType="Overview" />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/stemiolympiad/sector"
        element={
          <AuthenticatedRoute>
            <StemiReport reportType="Sector" />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/stemiolympiad/competition"
        element={
          <AuthenticatedRoute>
            <StemiReport reportType="Competition" />
          </AuthenticatedRoute>
        }
      />
      <Route path="/agentuploadhistory" element={<AgentUploadHistory />} />
      <Route
        path="/stemi"
        element={
          <RouteByRole roles={["STEMI_OFFICIAL", "STEMI_LEAD_AGENT"]}>
            <DataImport />
          </RouteByRole>
        }
      />
      <Route
        path="/uploadhistory"
        element={
          <RouteByRole roles={["ADMIN", "STEMI_OFFICIAL", "STEMI_LEAD_AGENT"]}>
            <History />
          </RouteByRole>
        }
      />
      <Route
        path="/errorlogs"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <ApplicationErrorList />
          </RouteByRole>
        }
      />
      <Route
        path="/errorlogs/:key"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <ViewApplicationLogs />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/stemi/olympiad/names"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <StemiOlympiadNameView />
          </RouteByRole>
        }
      />
      <Route
        path="/system/configurations"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <SystemConfig />
          </RouteByRole>
        }
      />
      <Route
        path="/system/addresscorrection"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <AddressList />
          </RouteByRole>
        }
      />
      <Route
        path="/system/addresscorrection/:key"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <AddressList />
          </RouteByRole>
        }
      />

      <Route
        path="/system/user-guide"
        element={
          <RouteByRole roles={["ADMIN"]}>
            <UserGuideView />
          </RouteByRole>
        }
      />

      {/* Only match this 👇️ when no other routes match */}
      <Route path="/offline" element={<OfflinePage subTitle={"Offline"} />} />
      <Route path="*" element={<InvalidPage subTitle={"Page Not Found"} />} />

      <Route
        path="/project-management"
        element={
          <RouteByRole roles={["ADMIN", "DSI_OFFICIAL", "SAASTA_OFFICIAL"]}>
            <ProjectView />
          </RouteByRole>
        }
      />

      <Route
        path="/project-management/status/:status"
        element={
          <RouteByRole roles={["ADMIN", "DSI_OFFICIAL", "SAASTA_OFFICIAL"]}>
            <ProjectView />
          </RouteByRole>
        }
      />
      <Route
        path="/project/:key"
        element={
          <RouteByRole roles={["ADMIN", "DSI_OFFICIAL", "SAASTA_OFFICIAL"]}>
            <ViewProjectDetails />{" "}
          </RouteByRole>
        }
      />
      <Route
        path="/data-upload"
        element={
          <RouteByRole roles={["NYS_DATA_UPLOADER", "EVENTS_DATA_UPLOADER"]}>
            <DataUpload />
          </RouteByRole>
        }
      />
      <Route
        path="/upload-history"
        element={
          <RouteByRole
            roles={[
              "ADMIN",
              "NYS_DATA_UPLOADER",
              "PROGRAMME_LEAD",
              "EVENTS_DATA_UPLOADER",
            ]}
          >
            <UploadHistory />
          </RouteByRole>
        }
      />
      <Route
        path="/volunteer-scientist"
        element={
          <RouteByRole
            roles={[
              "ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD", "EVENTS_LEAD", "VOL_SCI_LEAD"
            ]}
          >
            <VolunteerScientistHome />
          </RouteByRole>
        }
      />
      <Route
        path="/volunteer-scientist/:id"
        element={
          <RouteByRole roles={["ADMIN", "EVENTS_RATIFIER", "PROGRAMME_LEAD", "EVENTS_LEAD", "VOL_SCI_LEAD"]}>
            <VolunteerScientistDetail />
          </RouteByRole>
        }
      />
      <Route
        path="/volunteer-scientist-report"
        element={
          <AuthenticatedRoute>
            <VolunteerScientistReport />{" "}
          </AuthenticatedRoute>
        }
      />
    </Routes>
  );
};



export default AppRouter;
